module.exports = __webpack_public_path__ + "img/11.cb3d8017.jpg";